import { render, staticRenderFns } from "./ComplianceCheckbox.vue?vue&type=template&id=b21169be&scoped=true&"
import script from "./ComplianceCheckbox.vue?vue&type=script&lang=js&"
export * from "./ComplianceCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceCheckbox.vue?vue&type=style&index=0&id=b21169be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21169be",
  null
  
)

export default component.exports